export const SET_STATUS = 'SET_STATUS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_TECHNICIAN = 'SET_TECHNICIAN'
export const SET_TECHNICIANS = 'SET_TECHNICIANS'



// WEBPACK FOOTER //
// ./src/store/modules/technicians/types.js